import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Tabs } from '@ui/components/Tabs';

import { TournamentEntrance } from '@features/shared/api/typings';
import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';
import { OPEN_WITH_PRE_MODERATION_ENTRANCE } from '@features/tournament/ui/components/TournamentSettings/utils';

const entranceTabs: {
  value: TournamentEntrance | typeof OPEN_WITH_PRE_MODERATION_ENTRANCE;
  label: string;
  disabled?: boolean;
}[] = [
  { value: 'Open', label: 'Открытый' },
  {
    value: OPEN_WITH_PRE_MODERATION_ENTRANCE,
    label: 'Открытый (модерация)',
  },
  // { value: 'Rank', label: 'По рейтингу', disabled: true },
  { value: 'Invite', label: 'По приглашению' },
];

export function EntranceInput() {
  const { control } = useFormContext<TournamentEditFormValues>();

  return (
    <FormRow>
      <FormLabel>Допуск</FormLabel>
      <FormInput>
        <Controller
          name="entrance"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Tabs tabs={entranceTabs} value={value} onChange={onChange} disabled={disabled} />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
